var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Save scores to attributes"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _vm.vm.initialized === false
                      ? [_vm._m(0)]
                      : _vm.vm.initialized === true && _vm.vm.preview == null
                      ? [
                          _c("table", { staticClass: "table table-hover" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.vm.criteria, function (c) {
                                return _c("tr", { key: c.Id }, [
                                  _c("td", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(c.Name) +
                                        "\n                                        "
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-muted" }, [
                                      _vm._v(_vm._s(c.Path)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: c.AttributeId,
                                            expression: "c.AttributeId",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              c,
                                              "AttributeId",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          { domProps: { value: null } },
                                          [_vm._v("None")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.vm.attributes,
                                          function (attr) {
                                            return _c(
                                              "option",
                                              {
                                                key: attr.Id,
                                                domProps: { value: attr.Id },
                                              },
                                              [_vm._v(_vm._s(attr.Name))]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                ])
                              }),
                              0
                            ),
                          ]),
                        ]
                      : _vm.vm.initialized === true && _vm.vm.preview != null
                      ? [
                          _c(
                            "table",
                            { staticClass: "table table-hover table-bordered" },
                            [
                              _c("thead", [
                                _c(
                                  "tr",
                                  [
                                    _c("th", [_vm._v("Alternative")]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.MappedAttributeIds,
                                      function (attrId) {
                                        return _c("th", { key: attrId }, [
                                          _vm._v(
                                            _vm._s(_vm.getAttributeName(attrId))
                                          ),
                                        ])
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.vm.alternatives,
                                  function (alternative) {
                                    return _c(
                                      "tr",
                                      { key: alternative.Name },
                                      [
                                        _c("td", [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(alternative.Name) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.MappedAttributeIds,
                                          function (attrId) {
                                            return _c(
                                              "td",
                                              {
                                                key: attrId,
                                                class: {
                                                  "bg-warning":
                                                    _vm.IsExact(
                                                      alternative,
                                                      attrId
                                                    ) === false,
                                                },
                                              },
                                              [
                                                _vm.HasValue(
                                                  alternative,
                                                  attrId
                                                )
                                                  ? _c("div", [
                                                      _vm.HasDefinedAttributeValues(
                                                        alternative,
                                                        attrId
                                                      ) === false
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getScore(
                                                                  alternative,
                                                                  attrId
                                                                )
                                                              )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.HasDefinedAttributeValues(
                                                        alternative,
                                                        attrId
                                                      ) === true
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  _vm.getAttributeValueLabel(
                                                                    alternative,
                                                                    attrId
                                                                  )
                                                                ) +
                                                                " (" +
                                                                _vm._s(
                                                                  _vm.getAttributeValue(
                                                                    alternative,
                                                                    attrId
                                                                  )
                                                                ) +
                                                                ")\n                                            "
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.IsExact(
                                                        alternative,
                                                        attrId
                                                      ) === false
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-muted",
                                                            },
                                                            [
                                                              _c("br"),
                                                              _vm._v(
                                                                "Source score: " +
                                                                  _vm._s(
                                                                    _vm.getScore(
                                                                      alternative,
                                                                      attrId
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _vm.vm.preview == null
                      ? [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: { click: _vm.createAttribute },
                            },
                            [_vm._v("New attribute")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "button",
                                disabled: _vm.MappedAttributeIds.length == 0,
                              },
                              on: { click: _vm.loadPreview },
                            },
                            [_vm._v("Preview")]
                          ),
                        ]
                      : [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: { type: "button" },
                              on: { click: _vm.resetPreview },
                            },
                            [_vm._v("Back")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success",
                              attrs: { type: "button" },
                              on: { click: _vm.exportScores },
                            },
                            [_vm._v("Save")]
                          ),
                        ],
                  ],
                  2
                ),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h3", [
      _c("i", { staticClass: "fa fa-spinner fa-spin" }),
      _vm._v(" Loading..."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Criterion")]),
        _vm._v(" "),
        _c("th", [_vm._v("Attribute")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }